import React, { Component } from "react";
import "../../styles/signup.css";
import axios from "axios";
import { validateAll } from "indicative";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { recalculateBasket } from '../../shared/constants';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: "",
      password: "",
      password_confirmation: "",
      email: "",
      confirmationCode: null,
      showPassword: false,
      showPasswordConfirmation: false,
      smsOffersAllowed: false,
      errors: {
        phoneNumber: "",
        email: "",
        password: ""
      },
      responseError: "",
      showConfirmationBlock: false,
      successMessage: "",
      disabled: false
    };
  }

  toggleShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  toggleShowPasswordConfirmation = () => {
    this.setState(state => ({ showPasswordConfirmation: !state.showPasswordConfirmation }));
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangePhone = e => {
    const phoneFormat = "38" + e;
    const regex = /^\+?3?8?(0\d{9})$/;
    if (e === "" || regex.test(phoneFormat)) {
      this.setState({ phoneNumber: e })
      this.setState({errors: {phoneNumber: ""}});
    } else if(e.length === 10) {
      this.setState({ phoneNumber: "" })
      this.setState({errors: {phoneNumber: "Невірний формат номеру телефону"}});
    } else {
      this.setState({ phoneNumber: "" })
    }
  };


  handleSubmit = e => {
    e.preventDefault();
    this.setState({
      errors: {
        phoneNumber: "",
        email: "",
        password: ""
      },
      responseError: "",
      disabled: true
    });

    const data = this.state;

    const messages = {
      required: "Це поле є обов'язковим",
      "phoneNumber.required": "Введіть коректний номер телефону",
      "email.email": "Введіть коректний імейл",
      "password.confirmed": "Паролі не однакові ",
      min: "Довжина поля повинна бути не менше 5 символів",
      "phoneNumber.max": "Номер телефону має містити 10 цифр Формат: 0501234567",
      "phoneNumber.min": "Номер телефону має містити 10 цифр Формат: 0501234567",
      "email.max": "Довжина поля повинна бути не більшою 100 символів"
    };

    const rules = {
      phoneNumber: "required | number | min:10 | max:10",
      password: "required | string | min:5 | confirmed"
    };
    if (data.email && String(data.email).trim() !== "") {
      rules.email = "email | min:5 | max:100";
    }

    const request = {
      phoneNumber: data.phoneNumber,
      password: data.password,
      passwordConfirmation: data.password_confirmation,
      email: data.email,
      confirmationCode: data.confirmationCode,
      marketingSmsAllowed: data.smsOffersAllowed,
    }
    validateAll(data, rules, messages)
      .then(() => {
        const realThis = this;
        axios
          .post("/api/v1/auth/register", request)
          .then(function(res) {
            if (res.status === 200 && !res.data) {
              realThis.setState({
                confirmationCode: "",
                showConfirmationBlock: true,
                successMessage: "Код підтвердження відправлено на вказаний номер",
                disabled: false
              });
            } else if (res.status === 200 && res.data) {
              localStorage.setItem("token", res.data.data.token);
              recalculateBasket(res.data.data.token);
              const currentUrl = localStorage.getItem("currentUrl");
              const authPaths = ["/login", "/signup", "/restore-password"];
              const isValidReturnUrl = currentUrl && !authPaths.some(p => currentUrl.startsWith(p));
              realThis.props.history.push(isValidReturnUrl ? currentUrl : "/user/personal-cabinet");
            }
          })
          .catch(function(error) {
            const res = error.response;
            if (res.data.isError) {
              realThis.setState({
                responseError: res.data.errorMessage,
                errors: {},
                disabled: false
              });
            }
          });
      })
      .catch(errors => {
        this.setState({ responseError: null });
        const formattedErrors = {};
        errors.forEach(error => (formattedErrors[error.field] = error.message));
        this.setState({ errors: formattedErrors, disabled: false });
      });
  };

  render() {
    const {
      errors,
      responseError,
      successMessage,
      disabled,
      showPassword,
      showPasswordConfirmation
    } = this.state;
    return (
      <div id="signUpBody">
        <div className="signup-form">
          <form onSubmit={this.handleSubmit}>
            <h2 className="signup-form-title">Створити аккаунт</h2>
            <p className="lead">
              Накопичуйте персональну знижку та отримуйте спеціальні пропозиції.
            </p>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-user"></i>
                </span>
                <NumberFormat
                    className="form-control"
                    name="phoneNumber"
                    placeholder="Введіть номер телефону *"
                    format="+38 (###) ###-####"
                    mask="_"
                    onValueChange={value => this.onChangePhone(value.value)}
                />
              </div>
              <div className="form-field-success">{successMessage}</div>
              <div className="form-field-error">{errors.phoneNumber}</div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-paper-plane"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  name="email"
                  placeholder="Імейл (не обов’язково)"
                  onChange={this.onChange}
                />
              </div>
              <div className="form-field-error">{errors.email}</div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-lock"></i>
                </span>
                <div className="signup-password-input-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control signup-password-input"
                    name="password"
                    placeholder="Пароль *"
                    onChange={this.onChange}
                  />
                  <span
                    className="signup-password-toggle"
                    onClick={this.toggleShowPassword}
                    onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.toggleShowPassword(); } }}
                    role="button"
                    tabIndex={0}
                    title={showPassword ? "Приховати пароль" : "Показати пароль"}
                    aria-label={showPassword ? "Приховати пароль" : "Показати пароль"}
                  >
                    <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                </div>
              </div>
              <div className="form-field-error">{errors.password}</div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-lock"></i>
                  <i className="fa fa-check"></i>
                </span>
                <div className="signup-password-input-wrap">
                  <input
                    type={showPasswordConfirmation ? "text" : "password"}
                    className="form-control signup-password-input"
                    name="password_confirmation"
                    placeholder="Підтвердити пароль *"
                    onChange={this.onChange}
                  />
                  <span
                    className="signup-password-toggle"
                    onClick={this.toggleShowPasswordConfirmation}
                    onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.toggleShowPasswordConfirmation(); } }}
                    role="button"
                    tabIndex={0}
                    title={showPasswordConfirmation ? "Приховати пароль" : "Показати пароль"}
                    aria-label={showPasswordConfirmation ? "Приховати пароль" : "Показати пароль"}
                  >
                    <i className={showPasswordConfirmation ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                </div>
              </div>
              <div className="form-field-error">{errors.password}</div>
            </div>

            {this.state.showConfirmationBlock ? (
                <div className="form-group form-group-confirmation-code">
                  <div className="input-group input-group-confirmation-code">
                    <span className="input-group-addon">
                      <i className="fa fa-key" aria-hidden="true"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control confirmation-code-input"
                        name="confirmationCode"
                        placeholder="Введіть код підтвердження"
                        onChange={this.onChange}
                        autoFocus
                        aria-label="Код підтвердження"
                    />
                  </div>
                </div>
            ) : null}

            <div className="form-group form-group-signup-sms">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="signup-sms-offers"
                  checked={this.state.smsOffersAllowed}
                  onChange={e => this.setState({ smsOffersAllowed: e.target.checked })}
                  style={{ accentColor: '#212529' }}
                  aria-label="Отримувати персональні SMS"
                />
                <span className="form-check-label signup-sms-offers-label">
                  Отримувати персональні SMS. Відписка доступна у будь-який момент.
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="signup-sms-offers-tooltip" className="signup-sms-tooltip">
                        Ми надсилатимемо SMS з інформацією про акції, нові надходження та спеціальні пропозиції. Не більше 2-4 в місяць.
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-info-circle signup-sms-offers-info-icon" />
                  </OverlayTrigger>
                </span>
              </div>
            </div>

            <div className="form-group form-group-submit">
              <button
                type="submit"
                className="btn btn-dark btn-block btn-lg signup-submit-btn"
                disabled={disabled}
              >
                Зареєструватись
              </button>
            </div>
            <div className="form-field-error-special pt-2">{responseError}</div>
          </form>
          <div className="text-center">
            Вже маєте аккаунт? <Link to="/login">Увійти</Link>.
          </div>
        </div>
      </div>
    );
  }
}

export default SignUp;
